import { render, staticRenderFns } from "./additionalData.vue?vue&type=template&id=5c5a4890&scoped=true&"
import script from "./additionalData.vue?vue&type=script&lang=js&"
export * from "./additionalData.vue?vue&type=script&lang=js&"
import style0 from "./additionalData.vue?vue&type=style&index=0&id=5c5a4890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a4890",
  null
  
)

export default component.exports